import { z } from 'zod';

export const userTagSchema = z.object({
  id: z.string(),
  name: z.string(),
  category: z.string(),
  level: z.number(),
  /** Was named `categoryType` before the MDM hierarchy rename. */
  hierarchyName: z.string(),
});

export const usersTagsResponseSchema = z.array(
  z.object({
    userId: z.number(),
    tags: z.array(userTagSchema),
  }),
);

export type UserTag = z.infer<typeof userTagSchema>;
export type UsersTagsResponse = z.infer<typeof usersTagsResponseSchema>;
